<div id="register" fxLayout="column">
    <div
        id="register-form-wrapper"
        fxLayout="column"
        fxLayoutAlign="center center"
    >
        <div class="horizontal-stepper-wrapper">
            <mat-horizontal-stepper
                class="mat-elevation-z4"
                [linear]="true"
                (selectionChange)="resetValidation()"
            >
                <mat-step [stepControl]="horizontalStepperStep1">
                    <form
                        fxLayout="column"
                        [formGroup]="horizontalStepperStep1"
                        class="pt-8"
                    >
                        <ng-template matStepLabel>{{
                            'AUTH_PAGE.RECRUITER_INFO' | translate
                        }}</ng-template>

                        <div fxFlex="1 0 auto" fxLayout="column">
                            <mat-form-field appearance="outline" fxFlex="100">
                                <mat-label>{{
                                    'AUTH_PAGE.COMPANY_NAME' | translate
                                }}</mat-label>
                                <input
                                    matInput
                                    formControlName="companyName"
                                    required
                                />
                                <mat-error>{{
                                    'AUTH_PAGE.ENTER_COMPANY_NAME' | translate
                                }}</mat-error>
                            </mat-form-field>

                            <mat-form-field appearance="outline" fxFlex="100">
                                <mat-label>{{
                                    'AUTH_PAGE.ADDRESS' | translate
                                }}</mat-label>
                                <input
                                    matInput
                                    formControlName="companyAddress"
                                    required
                                />
                                <mat-error>{{
                                    'AUTH_PAGE.ENTER_COMPANY_ADDRESS'
                                        | translate
                                }}</mat-error>
                            </mat-form-field>

                            <fw-geography
                                (geographyEmitter)="completeLocation($event)"
                            ></fw-geography>

                            <mat-form-field appearance="outline" fxFlex="100">
                                <mat-label>{{
                                    'AUTH_PAGE.TAX_CODE' | translate
                                }}</mat-label>
                                <input
                                    matInput
                                    formControlName="taxCode"
                                    required
                                />
                                <mat-error>{{
                                    'AUTH_PAGE.PLEASE_ENTER_TAX_CODE'
                                        | translate
                                }}</mat-error>
                            </mat-form-field>

                            <mat-form-field
                                (click)="picker.open()"
                                appearance="outline"
                                fxFlex="100"
                            >
                                <mat-label>{{
                                    'AUTH_PAGE.TAX_CODE_DATE' | translate
                                }}</mat-label>
                                <input
                                    matInput
                                    (click)="picker.open()"
                                    [matDatepicker]="picker"
                                    formControlName="taxCodeIssueDate"
                                    placeholder="DD-MM-YYYY"
                                    required
                                    readonly
                                />
                                <mat-datepicker-toggle
                                    matSuffix
                                    [for]="picker"
                                ></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                                <mat-error>{{
                                    'AUTH_PAGE.PLEASE_ENTER_TAX_CODE_DATE'
                                        | translate
                                }}</mat-error>
                            </mat-form-field>

                            <mat-form-field appearance="outline" fxFlex="100">
                                <mat-label>{{
                                    'AUTH_PAGE.TAX_CODE_PLACE' | translate
                                }}</mat-label>
                                <input
                                    matInput
                                    formControlName="taxCodeIssuer"
                                    required
                                />
                                <mat-error>{{
                                    'AUTH_PAGE.PLEASE_ENTER_TAX_CODE_PLACE'
                                        | translate
                                }}</mat-error>
                            </mat-form-field>

                            <mat-form-field
                                appearance="outline"
                                fxFlex="100"
                                [class]="
                                    hasCodeValidation
                                        ? isValidCode
                                            ? 'valid-code'
                                            : 'invalid-code'
                                        : 'not-checked-code'
                                "
                            >
                                <mat-label>{{
                                    'AUTH_PAGE.REFERRAL_CODE' | translate
                                }}</mat-label>
                                <input
                                    matInput
                                    formControlName="referralCode"
                                    maxlength="8"
                                    (keyup)="checkReferralCode($event)"
                                />
                            </mat-form-field>

                            <div class="referral-code-guide">
                                <p>
                                    {{'AUTH_PAGE.REFERRAL_CODE_GUIDE_1' | translate}}
                                </p>
                                <p>
                                    {{'AUTH_PAGE.REFERRAL_CODE_GUIDE_2' | translate}}
                                </p>
                            </div>

                            <div class="agree-terms-container">
                                <mat-checkbox
                                    [checked]="agreeTerms"
                                    (change)="agreeTerms = $event.checked"
                                >
                                    {{ 'AUTH_PAGE.AGREE_WITH' | translate }}
                                    <a
                                        target="_blank"
                                        href="{{
                                            'AUTH_PAGE.PRIVACY_POLICY_LINK'
                                                | translate
                                        }}"
                                        >{{
                                            'AUTH_PAGE.PRIVACY_POLICY'
                                                | translate
                                        }}</a
                                    >
                                    {{ 'AUTH_PAGE.AND' | translate }}
                                    <a
                                        target="_blank"
                                        href="{{
                                            'AUTH_PAGE.TERMS_OF_USES_LINK'
                                                | translate
                                        }}"
                                        >{{
                                            'AUTH_PAGE.TERMS_OF_SERVICE'
                                                | translate
                                        }}</a
                                    >
                                </mat-checkbox>
                            </div>
                        </div>

                        <div fxLayout="row" fxLayoutAlign="center center">
                            <button
                                mat-raised-button
                                matStepperNext
                                type="button"
                                color="accent"
                                [disabled]="
                                    !agreeTerms ||
                                    horizontalStepperStep1.invalid
                                "
                            >
                                {{ 'AUTH_PAGE.NEXT' | translate }}
                            </button>
                        </div>
                    </form>
                </mat-step>

                <mat-step [stepControl]="horizontalStepperStep2">
                    <form
                        fxLayout="column"
                        [formGroup]="horizontalStepperStep2"
                        class="pt-8"
                    >
                        <ng-template matStepLabel>{{
                            'AUTH_PAGE.ADMIN_ACCOUNT' | translate
                        }}</ng-template>

                        <div fxFlex="1 0 auto" fxLayout="column">
                            <mat-form-field appearance="outline" fxFlex="100">
                                <mat-label>Email</mat-label>
                                <input
                                    matInput
                                    formControlName="email"
                                    [email]="true"
                                />
                                <mat-error
                                    *ngIf="
                                        horizontalStepperStep2
                                            .get('email')
                                            .hasError('required')
                                    "
                                >
                                    {{
                                        'AUTH_PAGE.PLEASE_ENTER_EMAIL'
                                            | translate
                                    }}
                                </mat-error>
                                <mat-error
                                    *ngIf="
                                        horizontalStepperStep2
                                            .get('email')
                                            .hasError('email')
                                    "
                                >
                                    {{ 'AUTH_PAGE.INVALID_EMAIL' | translate }}
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field appearance="outline" fxFlex="100">
                                <mat-label>{{
                                    'AUTH_PAGE.PASSWORD' | translate
                                }}</mat-label>
                                <input
                                    matInput
                                    placeholder="Password"
                                    [type]="hide ? 'password' : 'text'"
                                    formControlName="password"
                                    minlength="6"
                                    required
                                />
                                <mat-icon matSuffix (click)="hide = !hide"
                                    >{{
                                        hide ? 'visibility_off' : 'visibility'
                                    }}
                                </mat-icon>
                                <mat-error>
                                    {{
                                        'AUTH_PAGE.PLEASE_ENTER_PASSWORD_AT_LEAST_6_CHARACTERS'
                                            | translate
                                    }}
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field appearance="outline" fxFlex="100">
                                <mat-label>{{
                                    'AUTH_PAGE.CONFIRM_PASSWORD' | translate
                                }}</mat-label>
                                <input
                                    matInput
                                    placeholder="Password"
                                    [type]="hideC ? 'password' : 'text'"
                                    formControlName="passwordConfirm"
                                    minlength="6"
                                    required
                                />
                                <mat-icon matSuffix (click)="hideC = !hideC"
                                    >{{
                                        hideC ? 'visibility_off' : 'visibility'
                                    }}
                                </mat-icon>

                                <mat-error
                                    *ngIf="
                                        horizontalStepperStep2
                                            .get('passwordConfirm')
                                            .hasError('required')
                                    "
                                >
                                    {{
                                        'AUTH_PAGE.PLEASE_ENTER_CONFIRM_PASSWORD'
                                            | translate
                                    }}
                                </mat-error>
                                <mat-error
                                    *ngIf="
                                        !horizontalStepperStep2
                                            .get('passwordConfirm')
                                            .hasError('required') &&
                                        horizontalStepperStep2
                                            .get('passwordConfirm')
                                            .hasError('passwordsNotMatching')
                                    "
                                >
                                    {{
                                        'AUTH_PAGE.PASSWORD_NOT_MATCH'
                                            | translate
                                    }}
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field appearance="outline" fxFlex="100">
                                <mat-label>
                                    {{
                                        'AUTH_PAGE.ADMIN_FULL_NAME' | translate
                                    }}
                                </mat-label>
                                <input matInput formControlName="name" />
                                <mat-error
                                    *ngIf="
                                        horizontalStepperStep2
                                            .get('name')
                                            .hasError('required')
                                    "
                                >
                                    {{
                                        'AUTH_PAGE.PLEASE_ENTER_ADMIN_FULL_NAME'
                                            | translate
                                    }}
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field appearance="outline" fxFlex="100">
                                <mat-label>
                                    {{ 'AUTH_PAGE.GENDER' | translate }}
                                </mat-label>
                                <mat-select formControlName="gender">
                                    <mat-option class="option" value="MALE">
                                        {{ 'AUTH_PAGE.MALE' | translate }}
                                    </mat-option>
                                    <mat-option class="option" value="FEMALE">
                                        {{ 'AUTH_PAGE.FEMALE' | translate }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                            <mat-form-field appearance="outline" fxFlex="100">
                                <mat-label>
                                    {{ 'AUTH_PAGE.PHONE_NUMBER' | translate }}
                                </mat-label>
                                <input matInput formControlName="phone" />
                                <mat-error
                                    *ngIf="
                                        horizontalStepperStep2
                                            .get('phone')
                                            .hasError('required')
                                    "
                                >
                                    {{
                                        'AUTH_PAGE.PLEASE_ENTER_PHONE_NUMBER'
                                            | translate
                                    }}
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div fxLayout="row" fxLayoutAlign="center center">
                            <button
                                class="mr-8"
                                mat-raised-button
                                matStepperPrevious
                                type="button"
                                color="accent"
                            >
                                {{ 'AUTH_PAGE.BACK' | translate }}
                            </button>
                            <button
                                mat-raised-button
                                matStepperNext
                                type="button"
                                color="accent"
                                [disabled]="horizontalStepperStep2.invalid"
                            >
                                {{ 'AUTH_PAGE.NEXT' | translate }}
                            </button>
                        </div>
                    </form>
                </mat-step>

                <mat-step>
                    <ng-template matStepLabel>
                        {{ 'AUTH_PAGE.CONFIRM_REGISTER' | translate }}
                    </ng-template>

                    <div
                        class="h2 m-16"
                        fxLayout="row"
                        fxLayoutAlign="center center"
                    >
                        {{
                            'AUTH_PAGE.CONFIRMATION_EMAIL_SENT_TO' | translate
                        }}: {{ getEmail() }}
                    </div>

                    <div fxLayout="row" fxLayoutAlign="center center">
                        <button
                            mat-raised-button
                            type="button"
                            color="accent"
                            (click)="finishHorizontalStepper()"
                        >
                            {{ 'AUTH_PAGE.CONFIRM_REGISTER' | translate }}
                        </button>
                    </div>

                    <div
                        *ngIf="isError"
                        class="h2 m-16"
                        fxLayout="row"
                        fxLayoutAlign="center center"
                    >
                        <p class="error">
                            {{ 'AUTH_PAGE.ERROR_REGISTER' | translate }}
                        </p>
                    </div>
                </mat-step>
            </mat-horizontal-stepper>
        </div>
    </div>
</div>
